export const INITIAL_STATE = {
    is_show: false,
    header_banners: [
        {
            desktop_image_url: null,
            mobile_image_url: null,
            url: null,
            published_date: null,
            published_time: null,
        },
    ],
}

export const GET_FIELD_NAME = {
    header_banners: 'Header banners item',
}

export const GET_ITEM_FIELD_NAME = {
    desktop_image_url: 'Image desktop',
    mobile_image_url: 'Image mobile',
}

export const ITEM_FIELD_NAME_DETAIL = {
    ...GET_ITEM_FIELD_NAME,
    url: 'Link direction',
    published_at: 'Waktu Aktif',
}

export const ACTIVE_TIME_FIELD_NAME = ['published_date', 'published_time']
